<template>
<div class="flow-process-steps">
  <el-tabs type="border-card" v-model="activeName">
    <el-tab-pane name="schedule_where">
        <div class="flow-process-steps-item" slot="label">
          <template v-if="data_statistics.schedule_count">
            <el-badge :value="data_statistics.schedule_count" class="item">待办流程</el-badge>
          </template>
          <template v-else>待办流程</template>
        </div>
        <ProcessSteps v-if="re_load_status" :where="schedule_where" selectType="schedule"/>
    </el-tab-pane>
    <el-tab-pane name="self_where">
      <div class="flow-process-steps-item" slot="label">
        <template v-if="data_statistics.self_count">
          <el-badge :value="data_statistics.self_count" class="item">我发起的</el-badge>
        </template>
        <template v-else>我发起的</template>
      </div>
      <ProcessSteps v-if="re_load_status" :where="self_where" selectType="self"/>
    </el-tab-pane>
    <el-tab-pane name="handled_where">
      <div class="flow-process-steps-item" slot="label">
        <template v-if="data_statistics.handled_count">
          <el-badge :value="data_statistics.handled_count" class="item">我经办的</el-badge>
        </template>
        <template v-else>我经办的</template>
      </div>
      <ProcessSteps v-if="re_load_status" :where="handled_where" selectType="handled"/>
    </el-tab-pane>
    <el-tab-pane name="refill_where">
      <div class="flow-process-steps-item" slot="label">
        <template v-if="data_statistics.refill_count">
          <el-badge :value="data_statistics.refill_count" class="item">重填</el-badge>
        </template>
        <template v-else>重填</template>
      </div>
      <ProcessSteps v-if="re_load_status" :where="handled_where" selectType="refill"/>
    </el-tab-pane>
    <el-tab-pane name="draft_where">
      <div class="flow-process-steps-item" slot="label">
        <template>草稿</template>
      </div>
      <Draft v-if="re_load_status" :where="draft_where" />
    </el-tab-pane>
    <el-tab-pane name="revocation_where">
      <div class="flow-process-steps-item" slot="label">
        <template>已撤销</template>
      </div>
      <Revocation v-if="re_load_status" :where="revocation_where" />
    </el-tab-pane>
  </el-tabs>
  <div class="re_btn">
    <el-button icon="el-icon-refresh" circle @click="reLoad"></el-button>
  </div>
</div>
</template>

<script>
import ProcessSteps from "./components/ProcessSteps";
import Draft from "./components/Draft";
import Revocation from "./components/Revocation"
import Http from "./common/Http";
export default {
  name: "FlowProcessStepsHandled",
  components: {ProcessSteps, Draft, Revocation},
  data(){
    return{
      activeName:"handled_where",
      schedule_where:{
        'fps.user_id':0,
        'fps.posted':1,
        'fps.is_push':1,
        'fps.is_handle':0,
      },
      self_where:{
        'fps.user_id':0,
        'fps.business_type':1,
      },
      handled_where:{
        'fps.user_id':0,
        'fps.is_push':1,
      },
      draft_where:{

      },
      revocation_where: {

      },
      data_statistics:{
        schedule_count:0,
        self_count:0,
        handled_count:0
      },
      re_load_status:true,
    }
  },
  activated() {
    this.getProcessStepsStatistics()
  },
  methods:{
    getProcessStepsStatistics(){
      const that = this;
      Http.get("flow/FlowProcessSteps/getProcessStepsStatistics",{},res=>{
        if(res.code) {
          that.data_statistics=res.data
        }
      })
    },
    reLoad(){
      const that = this;
      that.getProcessStepsStatistics();
      that.re_load_status=false;
      that.$nextTick(function () {
        that.re_load_status=true;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  /deep/ .el-tabs__item{
    height: unset;
  }
}
.flow-process-steps{
  position: relative;
  .flow-process-steps-item{
    padding-top: 15px;
  }
  .re_btn{
    position: absolute;
    right: 30px;
    top: 10px;
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowProcessStepsHandled.vue